import React from 'react';
import LayoutApp from '@zmedia/bm-soccer-ui/layout';
import { MatchDetail } from '@zmedia/bm-soccer-ui/modules/match/detail';
import PageCustomService from '@zmedia/bm-soccer-ui/service/PageCustomService';
import { GetServerSidePropsContext } from 'next';
import { IResponse } from 'src/interface';
import { ContainerUI } from 'src/layout/ui';
import { ContentItem } from 'src/modules/content/components/item/ContentItem';

export function MatchDetailPage({
    resp,
    isBot,
}: {
    resp: IResponse<any>;
    isBot: boolean;
}) {
    const { data } = resp;
    const listProps = {
        ContentItem: ContentItem,
        ContentItemProps: {
            lazyloadImage: !isBot,
            showDescription: isBot,
            truncateDescription: !isBot,
        },
    };
    return (
        <>
            <ContainerUI {...data} />
            <LayoutApp isMobile={true} {...data}>
                <MatchDetail {...data} listProps={listProps} />
            </LayoutApp>
        </>
    );
}

export async function getServerSideProps(
    ctx: GetServerSidePropsContext
): Promise<any> {
    const id = ctx?.params?.id;
    const resp = await PageCustomService.get(ctx, 'match', { id: id });
    return {
        props: {
            ...resp.props,
            isBlankLayout: true,
        },
    };
}

export default MatchDetailPage;
